// @ts-nocheck
// @ts-ignore
/* eslint-disable */
/**
 *
 * SelectCustom
 *
 */

import React, { memo, useEffect, useState } from "react";
// components
import { Button, Divider, Select, Skeleton, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

function SelectCustom({
  // default props
  className,
  children,
  item,
  listOptions,
  renderExtraSelect = false,
  mode,
  placeholder,
  allowClear,
  disabled,
  refForm,
  showSearch,
  filterOption,
  filterSort,
  optionFilterProp,
  ready,
  ...rest
}) {
  const { t } = useTranslation(); // Initialize useTranslation

  if (ready === false) {
    return <Skeleton />;
  }

  // Multiple
  const [selectedItems, setSelectedItems] = useState(
    listOptions.map(e => e.key),
  );

  useEffect(() => {
    setSelectedItems(item.value.map(e => e));
  }, [listOptions]);

  // Single
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (item.onChange !== undefined) {
      item.onChange(selectedItems);
    }
    refForm.current.setFieldsValue({ [item.name]: selectedItems });
  }, [selectedItems, item, refForm]);

  const tagRender = props => {
    const { value, closable, onClose } = props;
    const onPreventMouseDown = event => {
      event.preventDefault();
      event.stopPropagation();
    };
    const label = listOptions.find(i => i.key === value)?.label;
    return (
      <Tag
        color={"#eaeaea"}
        closable={closable}
        onClose={onClose}
        style={{
          padding: 3,
          margin: 3,
          fontSize: 16,
          fontWeight: "500",
          color: "black",
        }}
        onMouseDown={onPreventMouseDown}
      >
        {label}
      </Tag>
    );
  };

  const selectAll = () => {
    setSelectedItems(listOptions.map(e => e.key));
  };
  const deselectAll = () => {
    setSelectedItems([]);
  };

  return (
    <Select
      placeholder={placeholder}
      optionFilterProp={optionFilterProp}
      filterOption={filterOption}
      filterSort={filterSort}
      mode={mode}
      allowClear={allowClear}
      disabled={disabled}
      showSearch={showSearch}
      value={mode === "multiple" ? selectedItems : selectedItem}
      defaultValue={mode === "multiple" ? selectedItems : selectedItem}
      onDeselect={e => {
        setSelectedItems(selectedItems.filter(o => o !== e));
      }}
      tagRender={tagRender}
      onSelect={newItem => {
        setSelectedItems([...selectedItems, newItem]);
      }}
      dropdownRender={menu =>
        renderExtraSelect ? (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />

            <Space style={{ padding: "0 8px 4px" }}>
              <Button type="primary" onClick={selectAll}>
                {t("selectCustom.selectAll")}
              </Button>
              <Button type="default" onClick={deselectAll}>
                {t("selectCustom.deselectAll")}
              </Button>
            </Space>
          </>
        ) : (
          menu
        )
      }
    >
      {listOptions.map((option, i) => (
        <Option
          {...option}
          key={option?.key || option?.value}
          value={option?.value || option?.key}
          color={option?.color}
        >
          {option?.label}
        </Option>
      ))}
    </Select>
  );
}

SelectCustom.defaultProps = {};
SelectCustom.propTypes = {};

export default memo(SelectCustom);
